export default __webpack_public_path__ + "static/media/gw3.4edf14b2.webp";